import {
  Component,
  ViewEncapsulation,
  OnInit,
  OnDestroy, ViewChild, Inject, AfterViewInit
} from '@angular/core';
import {
  State
} from '@progress/kendo-data-query';
import {
  DataStateChangeEvent,
  GridDataResult, SelectionEvent,
} from '@progress/kendo-angular-grid';
import {
  trigger,
  state,
  style,
  animate,
  transition
} from '@angular/animations';
import {
  Observable
, Subscription} from 'rxjs';
import {
  FormControl
} from '@angular/forms';
import * as moment from 'moment';
import {Router} from '@angular/router';
import {debounceTime, distinctUntilChanged} from 'rxjs/operators';
import {DistributorAccountsService} from './distributor-accounts.service';
import {UserContext} from '../services/user-context';
import {DistributorLocationsService} from './distributor-locations.service';
import {DOCUMENT} from '@angular/common';
import {HttpParams} from '@angular/common/http';
import {ApiService} from '../services/api';
import {GoogleMapsAPIWrapper, AgmMap, LatLngBounds, LatLngBoundsLiteral} from '@agm/core';

declare var google: any;

@Component({
  selector: 'app-distributor-locations',
  encapsulation: ViewEncapsulation.None,
  templateUrl: 'distributor-locations.template.html',
  animations: [
    trigger('slideIn', [
      state('*', style({ 'overflow-y': 'hidden' })),
      state('void', style({ 'overflow-y': 'hidden' })),
      transition('* => void', [
        style({ height: '*' }),
        animate(250, style({ height: 0 }))
      ]),
      transition('void => *', [
        style({ height: '0' }),
        animate(250, style({ height: '*' }))
      ])
    ])
  ]
})
export class DistributorLocationsComponent implements OnInit, AfterViewInit, OnDestroy {
  @ViewChild(AgmMap, {static: false})
  public agmMap: AgmMap;

  public view: Observable<GridDataResult>;
  public subscription: Subscription;
  public state: State = {
    skip: 0,
    take: 10
  };

  public searchText = new FormControl();

  loading = false;
  lat = 35.268107;
  lng = -90.744821;
  zoom = 4;

  public crumbs: any[] = [
    {label: 'Locations'}
  ];

  public markers: any[] = [];
  public mapStyles = [
    {elementType: 'geometry', stylers: [{color: '#aec3cb'}]},
    {elementType: 'labels.text.stroke', stylers: [{'visibility': 'off'}]},
    {elementType: 'labels.text.fill', stylers: [{color: '#888888'}]},
    {
      featureType: 'administrative.locality',
      elementType: 'labels.text.fill',
      stylers: [{color: '#555555'}]
    },
    {
      featureType: 'poi',
      elementType: 'labels.text.fill',
      stylers: [{'visibility': 'off'}]
    },
    {
      featureType: 'poi.park',
      elementType: 'geometry',
      stylers: [{color: 'transparent'}]
    },
    {
      featureType: 'poi.park',
      elementType: 'labels.text.fill',
      stylers: [{color: 'transparent'}]
    },
    {
      featureType: 'road',
      elementType: 'geometry',
      stylers: [{color: '#c0d7e0'}]
    },
    {
      featureType: 'road',
      elementType: 'geometry.stroke',
      stylers: [{color: '#bbdefb'}]
    },
    {
      featureType: 'road',
      elementType: 'labels.text.fill',
      stylers: [{color: '#9ca5b3'}]
    },
    {
      featureType: 'road.highway',
      elementType: 'geometry',
      stylers: [{color: '#c0d7e0'}]
    },
    {
      featureType: 'road.highway',
      elementType: 'geometry.stroke',
      stylers: [{color: '#c0d7e0'}]
    },
    {
      featureType: 'road.highway',
      elementType: 'labels.text.fill',
      stylers: [{color: '#81d4fa'}]
    },
    {
      featureType: 'transit',
      elementType: 'geometry',
      stylers: [{color: '#2f3948'}]
    },
    {
      featureType: 'transit.station',
      elementType: 'labels.text.fill',
      stylers: [{color: 'transparent'}]
    },
    {
      featureType: 'water',
      elementType: 'geometry',
      stylers: [{color: '#f1f4f5'}]
    },
    {
      featureType: 'water',
      elementType: 'labels.text.fill',
      stylers: [{color: 'transparent'}]
    },
    {
      featureType: 'water',
      elementType: 'labels.text.stroke',
      stylers: [{color: 'transparent'}]
    }
  ];

  constructor(
    private router: Router,
    private api: ApiService,
    private service: DistributorLocationsService,
    private userContext: UserContext,
    @Inject(DOCUMENT) private document: Document) {

    this.view = service;
    this.subscription = service.subscription;
    this.getLocations('');
  }

  public ngOnInit(): void {
    this.searchText.valueChanges
      .pipe(debounceTime(400), distinctUntilChanged())
      .subscribe((term) => {
        if (term.length >= 3 || term.length === 0) {
          this.state.skip = 0;
          this.getLocations(term);
        }
      });
  }

  public ngAfterViewInit(): void {
    this.agmMap.mapReady.subscribe(map => {

      const params = new HttpParams()
        .set('map', 'true');

      if ( this.userContext.account ) {
        params.set('account', this.userContext.account.id || '');
      }

      this.api.get<any>(`/distributor/${encodeURI(this.userContext.user.reference || '0')}/locations`, params)
        .subscribe(result => {
          if (result) {
            const markerArray: any[] = [];
            result.map( (marker) => {
              if ( marker.latlng ) {
                markerArray.push({latitude: marker.latlng[0], longitude: marker.latlng[1]});
              }
            });
            this.markers = markerArray;
            this.centerMap(map);
          }
        });
    });
  }

  public ngOnDestroy(): void {
  }

  public selectedRow(event: SelectionEvent) {
    //this.userContext. = event.selectedRows[0].dataItem;
    //this.router.navigate(['distributor', 'locations', `${event.selectedRows[0].dataItem._id}`]);
  }

  public centerMap(map): void {
    const bounds: LatLngBounds = new google.maps.LatLngBounds();
    for (const mm of this.markers) {
      bounds.extend(new google.maps.LatLng(mm.latitude, mm.longitude));
    }
    map.fitBounds(bounds);
    if ( map.getZoom() > 7 ) {
      map.setZoom(7);
    }
  }

  public onMapReady($event) {
    this.agmMap.triggerResize(true);
  }

  public filterFieldChanged(): void {
    this.getLocations(this.searchText.value || '');
  }

  public dataStateChange(state: DataStateChangeEvent): void {
    this.state = state;
    this.getLocations('');
  }

  public getLocations(search) {
    this.loading = true;
    const page = this.state.skip / this.state.take + 1;
    const limit = this.state.take;

    this.service.getLocations(page, limit, () => {
      this.loading = false;
    }, (this.userContext.account || {}).id, search);
  }

}
